import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    logout: {
        defaultMessage: 'Logout',
        id: 'iaso.logout',
    },
    source: {
        defaultMessage: 'Source',
        id: 'iaso.forms.source',
    },
    version: {
        defaultMessage: 'Version',
        id: 'iaso.label.version',
    },
    userManual: {
        defaultMessage: 'User manual',
        id: 'iaso.label.userManual',
    },
    viewUserManual: {
        defaultMessage: 'View user manual',
        id: 'iaso.tooltip.viewUserManual',
    },
    djangoAdmin: {
        defaultMessage: 'Django Admin Panel',
        id: 'iaso.label.djangoAdmin',
    },
    iasoVersion: {
        defaultMessage: 'App version',
        id: 'iaso.label.iasoVersion',
    },
});

export default MESSAGES;
